// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4622cd55","455":"cc85a56f","977":"c03c92ec"}[chunkId] + ".chunk.js";
};